// 筛选项和筛选id之间的映射关系

export const siftParams = {
  datePhase: 'datePhase',
  timePhase: 'timePhase',
  subjects: 'subjectId',
  textbookContents: 'textbookContentId',
  terms: 'termId',
  versions: 'versionId',
  studyPhases: 'studyPhaseId',
  progresses: 'progressId',
  difficulties: 'difficultyId',
  times: 'timeId',
  timeSlots: 'timeSlotId',
  knowledges: 'knowledgeId',
  labels: 'labelId',
  textbooks: 'textbookId',
}



// WEBPACK FOOTER //
// ./src/defines/siftParams.js